import React from 'react';

const Header = () => {
  return (
    <>
      {/* Top Navigation Bar */}
      <nav className="top-nav">
        <div className="container">
          <div className="nav-brand">
            <span className="brand-text">AWS Community GameDay Europe</span>
          </div>
          <div className="nav-links">
            <a href="#about">The Event</a>
            <a href="#usergroups">User Groups</a>
            <a href="#join">Want to Join?</a>
            <a href="#organizers">Organizers</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-left">
              <img src={`${process.env.PUBLIC_URL}/Logo-Gameday-2026.png`} alt="AWS GameDay" className="hero-logo" />
            </div>
            <div className="hero-right">
              <h1>AWS Community GameDay</h1>
              <h2 className="gameday-title">Builder's Trial</h2>
              <p className="hero-subtitle">March 17, 2026 • 6:00 PM CET • Europe</p>
              <div className="hero-description">
                <p>Join the largest collaborative AWS experience! A unique hybrid event with a custom GameDay built exclusively for our European communities.</p>
              </div>
              {/* <div className="hero-cta">
                {/* <a href="#registration" className="btn btn-primary">S'inscrire maintenant</a> /}
              <a href="#about" className="btn btn-outline">En savoir plus</a>
            </div> */}
            </div>
          </div>
        </div>
      </section >
    </>
  );
};

export default Header;